import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "rt-portal-orders_fill",
  "use": "rt-portal-orders_fill-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 1024 1024\" id=\"rt-portal-orders_fill\">\r\n<path d=\"M848,80H178c-35.2,0-64,28.8-64,64v736c0,35.2,28.8,64,64,64h538c107.8,0,196-88.2,196-196V144C912,108.8,883.2,80,848,80z\r\n\t M352,288h210c22,0,40,18,40,40s-18,40-40,40H352c-22,0-40-18-40-40S330,288,352,288z M452,735H352c-22,0-40-18-40-40s18-40,40-40\r\n\th100c22,0,40,18,40,40S474,735,452,735z M672,552H352c-22,0-40-18-40-40s18-40,40-40h320c22,0,40,18,40,40S694,552,672,552z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/svg-sprite-loader/lib/loader.js?{"symbolId":"rt-portal-[name]"}!./src/assets/icons/svgs/orders_fill.svg
// module id = 1329
// module chunks = 91